import { RouteItem } from '@eastcoal/router/types/route'

import { INTERNAL_COLLECTION_LIST_PAGE_PATH } from './constants/path'
import {
  INTERNAL_COLLECTION_ABANDON_MANAGE_ACTION_UUID,
  INTERNAL_COLLECTION_WAIT_AUDIT_MANAGE_ACTION_UUID,
  INTERNAL_COLLECTION_WAIT_MATCH_MANAGE_ACTION_UUID,
  INTERNAL_COLLECTION_WAIT_RECHARGE_MANAGE_ACTION_UUID
} from './constants/uuid'

export const internalCollectionRoute: RouteItem = {
  title: '内部收款审核',
  path: INTERNAL_COLLECTION_LIST_PAGE_PATH,
  hideChildrenInMenu: true,
  uuid: INTERNAL_COLLECTION_LIST_PAGE_PATH,
  Component: () => import('./index'),
  children: [
    {
      title: '待匹配',
      uuid: INTERNAL_COLLECTION_WAIT_MATCH_MANAGE_ACTION_UUID
    },
    {
      title: '待入金',
      uuid: INTERNAL_COLLECTION_WAIT_RECHARGE_MANAGE_ACTION_UUID
    },
    {
      title: '待审核',
      uuid: INTERNAL_COLLECTION_WAIT_AUDIT_MANAGE_ACTION_UUID
    },
    {
      title: '非保证金',
      uuid: INTERNAL_COLLECTION_ABANDON_MANAGE_ACTION_UUID
    }
  ]
}
